import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'shared/store';

export const shopApiPost = createApi({
  reducerPath: 'shopApiPost',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Shops', 'CreateShops'],
  endpoints: (builder) => ({
    // Дублирование из features для скрытия ошибки, потом убрать
    getMe: builder.query({
      query: () => ({
        url: '',
      }),
    }),
  }),
});
